export default __webpack_public_path__ + "static/media/bg_texture-dust-white.20611aa3.jpg";